/* eslint-disable */
import React, { Component } from 'react'
import styles from './style.module.less'
export default class extends Component {
  map
  mapContainer
  marker
  static defaultProps = {
    width: '100%',
    height: 400,
    zoom: 11,
    visible: 'none',
    address: '',
    isShowToolBar: false
  }
  constructor(props) {
    super(props)
    this.mapContainer = '_map_' + Math.random().toFixed(8)
  }

  //初始化地图,默认显示当前所在地址
  initMap = () => {
    const { center, zoom } = this.props
    return new AMap.Map(this.mapContainer, {
      resizeEnable: true,
      zoom,
      center
    })
  }
  initMarker = () => {
    return new AMap.Marker()
  }

  //设置地图工具
  setMapTool = () => {
    const map = this.map
    const address = this.props.address
    const marker = this.marker
    const { isShowToolBar, getPosition } = this.props
    let inputAddress = this.props.address
    /*添加各种功能*/
    AMap.plugin(
      [
        'AMap.ToolBar',
        'AMap.Autocomplete',
        'AMap.PlaceSearch',
        'AMap.Geocoder'
      ],
      () => {
        const toolBar = new AMap.ToolBar()
        /*创建和添加工具条*/
        {
          isShowToolBar ? map.addControl(toolBar) : null
        }
        /*实现输入提示和搜索功能*/
        const autoOptions = {
          /*city: "", //城市，默认全国*/
          input: this.mapContainer + '_map_search', //使用联想输入的input的id
          map: map
        }
        const autocomplete = new AMap.Autocomplete(autoOptions)
        const placeSearch = new AMap.PlaceSearch({
          // city:'北京',
          map: map,
          pageSize: 1
        })
        autocomplete.search(address)

        AMap.event.addListener(autocomplete, 'select', e => {
          placeSearch.setCity(e.poi.adcode)
          placeSearch.search(e.poi.name, (status, result) => {
            if (status === 'complete' && result.info === 'OK') {
              let point = [
                result.poiList.pois[0].location.lng,
                result.poiList.pois[0].location.lat
              ]
              inputAddress = result.poiList.pois[0].name
              getPosition && getPosition(point, inputAddress)
              map.setCenter(point)
              marker.setMap(map)
              marker.setPosition(point)
            }
          })
        })
      }
    )
  }
  componentDidMount() {
    const { afterRender } = this.props
    this.map = this.initMap()
    this.marker = this.initMarker()
    this.setMapTool()
    afterRender && afterRender(this.map, this.marker)
  }
  render() {
    const { width, height, address, visible } = this.props

    return (
      <div>
        <input
          placeholder="请输入地址"
          type="text"
          style={{ zIndex: 9999, display: visible }}
          className={styles.map_search}
          defaultValue={address}
          id={this.mapContainer + '_map_search'}
        />
        <div
          className={styles.container}
          style={{ width, height }}
          id={this.mapContainer}
        />
      </div>
    )
  }
}
